import { render, staticRenderFns } from "./RecipesFilterPage.vue?vue&type=template&id=caee83ae&"
import script from "./RecipesFilterPage.vue?vue&type=script&lang=js&"
export * from "./RecipesFilterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports